import axios from 'axios';

import {
  CountryConfigs,
  CreateProductPayload,
  PutProductsCsvResponse,
  CreateProductResponse,
  ProductMedia,
  ProductBrand,
  ProductBrandStatus,
} from './types';

export const api = axios.create({
  baseURL: process.env.PRODUCT_INFORMATION_CATALOG_URI,
});

export const getCountryConfigs = (countryCode: string) =>
  api.get<CountryConfigs>(`/v1/configs/${countryCode}`).then(res => res.data);

export const uploadCsvProducts = (csvContent: string, options: { dryRun: boolean }) =>
  api.put<PutProductsCsvResponse>(`/v1/products/csv?dryRun=${options.dryRun}`, csvContent).then(res => res.data.data);

export const createProduct = (countryCode: string, payload: CreateProductPayload) =>
  api.post<CreateProductResponse>(`/v1/catalogs/${countryCode}/products`, payload).then(res => res.data);

export const createMediaFromUrl = (url: string) =>
  api
    .post<ProductMedia>('/v1/media/url', {
      type: 'JPEG',
      source: url,
    })
    .then(res => res.data);

const BRAND_STATUS: ProductBrandStatus = 'ACTIVE';

export const searchActiveBrands = (query: string, limit = 10) =>
  api
    .get<{ brands: ProductBrand[] }>('/v1/brands', { params: { query, limit, status: BRAND_STATUS } })
    .then(res => res.data.brands);

export const getBrandById = (brandId: string) => api.get<ProductBrand>(`/v1/brands/${brandId}`).then(res => res.data);

export default api;
